<template>
  <div id="sidebar">
    <div class="logo" :class="collapse ? 'collapse-logo-style' : ''">
      <span v-if="!collapse">客服管理后台</span>
    </div>
    <el-menu
      :default-active="siderActive"
      class="el-menu-vertical-demo"
      background-color="#273543"
      text-color="#fff"
      active-text-color="#fff"
      :collapse="collapse">
      <el-submenu index="index">
        <template slot="title">
          <i class="el-icon-document"></i>
          <span>首页</span>
        </template>
        <el-menu-item-group>
          <router-link :to="{name: 'Index'}">
            <el-menu-item index="Index">首页</el-menu-item>
          </router-link>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu :index="(index + 1) + ''" v-for="(item, index) in siderData" :key="index">
        <template slot="title">
          <i class="icon iconfont" :class="item.icon"></i>
          <span>{{item.menuName}}</span>
        </template>
        <div v-for="(items, i) in item.menuList" :key="i">
          <el-menu-item-group v-if="!items.menuList">
            <router-link :to="{name: items.router}">
              <el-menu-item :index="(items.router) + ''">{{items.menuName}}</el-menu-item>
            </router-link>
          </el-menu-item-group>
          <el-submenu v-if="items.menuList" :index="(items.id) + ''">
            <template slot="title">{{items.menuName}}</template>
            <router-link v-for="(ele, y) in items.menuList" :key="y" :to="{name: ele.router}">
              <el-menu-item :index="(ele.router) + ''">{{ele.menuName}}</el-menu-item>
            </router-link>
          </el-submenu>
        </div>
      </el-submenu>
      <el-submenu index="Password">
        <template slot="title">
          <i class="icon iconfont icon-password"></i>
          <span>修改密码</span>
        </template>
        <el-menu-item-group>
          <router-link :to="{name: 'Password'}">
            <el-menu-item index="Password">修改密码</el-menu-item>
          </router-link>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>
</template>
<script>
export default {
  created () {
    // 打印是否登录
    console.log(this.$store.state.Auth.sign)
    this.siderData = this.$store.state.Auth.sider
    this.siderData.forEach(item => {
      item.menuList.forEach(ele => {
        if (ele.menuList) {
          ele.menuList.forEach(items => {
            if (items.router === this.$route.meta.parent) {
              global.$sider = items.id
              global.$siderItem = items
            }
          })
        } else {
          if (ele.router === this.$route.meta.parent) {
            global.$sider = ele.id
            global.$siderItem = ele
          }
        }
      })
    })
  },
  watch: {
    $route (to, from) {
      this.siderActive = this.$route.meta.parent
      this.siderData.forEach(item => {
        item.menuList.forEach(ele => {
          if (ele.menuList) {
            ele.menuList.forEach(items => {
              if (items.router === this.$route.meta.parent) {
                global.$sider = items.id
                global.$siderItem = items
              }
            })
          } else {
            if (ele.router === this.$route.meta.parent) {
              global.$sider = ele.id
              global.$siderItem = ele
            }
          }
        })
      })
    }
  },
  computed: {
    collapse () {
      return this.$store.state.Auth.collapse
    }
  },
  data () {
    return {
      siderActive: this.$route.meta.parent,
      siderData: []
    }
  },
  methods: {
  },
  mounted () {
    console.log(global.$siderItem)
  }
}
</script>
<style lang="less" scoped>
.main-sider .el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 210px;
}
#sidebar{
  background-color: #273543;
  .logo{
    width: 210px;
    height: 64px;
    line-height: 64px;
    box-sizing: border-box;
    color: #fff;
    font-weight: 600;
    transition: all .4s;
    span{
      margin-left: 33px;
      font-size: 24px;
    }
    &.collapse-logo-style{
      width: 0;
    }
  }
  &>.el-menu{
    height: calc(100vh - 64px);
    overflow-y: auto;
    .icon{
      font-size: 16px;
      margin-right: 10px;
    }
    .el-menu-item{
      &.is-active{
        background-color: #3388FF!important;
        transition: all .6s;
      }
    }
    /deep/.el-menu-item-group__title{
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Public/Sider.vue